import styled from "styled-components";

export const DivLoader = styled.div`
display: flex;
justify-content: center;
align-items: center;
height: '100vh'
`;